const STORAGE_KEY = 'vb_affiliate_click_id';
const TRACK_BASE = String(import.meta.env.VITE_TRACK_BASE_URL || 'https://vurgun.click').replace(/\/$/, '');

export function captureAffiliateClickFromUrl(search = window.location.search, { loggedIn = false } = {}) {
  try {
    if (loggedIn) {
      clearAffiliateClickId();
      return null;
    }
    const params = new URLSearchParams(search);
    const raw = params.get('click_id') || params.get('btag') || '';
    const value = String(raw || '').trim();
    if (!value || value.length > 64) return getAffiliateClickId();
    if (!/^[A-Za-z0-9_-]+$/.test(value)) return getAffiliateClickId();
    window.localStorage.setItem(STORAGE_KEY, value);
    return value;
  } catch {
    return null;
  }
}

export function getAffiliateClickId() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export function clearAffiliateClickId() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function stripAffiliateParamsFromUrl() {
  try {
    const url = new URL(window.location.href);
    let changed = false;
    for (const key of ['btag', 'click_id']) {
      if (url.searchParams.has(key)) {
        url.searchParams.delete(key);
        changed = true;
      }
    }
    if (!changed) return;
    const qs = url.searchParams.toString();
    const next = `${url.pathname}${qs ? `?${qs}` : ''}${url.hash || ''}`;
    window.history.replaceState(window.history.state, '', next);
  } catch {
    /* ignore */
  }
}

export function commitAffiliateTrackingUrl(code) {
  const clean = String(code || '').trim();
  if (!clean) return null;
  return `${TRACK_BASE}/r/${encodeURIComponent(clean)}?go=1`;
}

export function affiliateCodeFromPath(pathname = window.location.pathname) {
  const m = String(pathname || '').match(/\/aff\/([^/\?#]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}
